var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],ref:"transitionContainer1",staticClass:"transitionContainer1"},[_c('div',{ref:"parapara",staticClass:"paraparaTransContainer",style:({
      backgroundPosition: (_vm.bgX + "px " + _vm.bgY + "px"),
      backgroundSize: (_vm.bgSizeX + "px " + _vm.bgSizeY + "px")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }